<template>
	<div
		ref="bookerRef"
		class="global-booker__container"
		:class="{ 'global-booker__nav-container': nav, 'global-booker__nav-container--mobile': accordion }">
		<div class="global-booker__field global-booker__start-location">
			<v-btn flat class="global-booker__field-button global-booker__field-button--place" @click="openLocationMenu(EBookerLocationType.START)">
				<GlobalIcon :name="startLocationIcon" :height="20" class="global-booker__field-icon"></GlobalIcon>
				<Transition name="fade" mode="out-in">
					<div v-if="!bookerState.selectedLocations.start" class="global-booker__field-content">
						<div class="global-booker__field-label">{{ $t('components.booker.container.start_location_label') }}</div>
						<div class="global-booker__field-value">{{ $t('components.booker.container.start_location_placeholder') }}</div>
					</div>
					<div v-else class="global-booker__field-content">
						<Transition name="fade" mode="out-in">
							<template v-if="bookerState.selectedLocations.start.isDelivery">
								<div v-if="!bookerState.otherEndLocation" class="global-booker__field-label">
									{{ $t('components.booker.container.substitution_and_pickup_address') }}
								</div>
								<div v-else class="global-booker__field-label">{{ $t('components.booker.container.car_substitution_address') }}</div>
							</template>
							<template v-else>
								<div v-if="!bookerState.otherEndLocation" class="global-booker__field-label">
									{{ $t('components.booker.container.pickup_dropoff_location_label') }}
								</div>
								<div v-else class="global-booker__field-label">
									{{ $t('components.booker.container.start_location_placeholder') }}
								</div>
							</template>
						</Transition>
						<div class="global-booker__field-value">
							<!-- <span v-if="bookerState.selectedLocations.start.city">{{ bookerState.selectedLocations.start.city }},</span> -->
							{{ title(bookerState.selectedLocations.start) }}
						</div>
					</div>
				</Transition>
			</v-btn>
			<GlobalBookerLocationMenu
				v-if="bookerState.isStartLocationMenuOpen"
				v-model="bookerState.isStartLocationMenuOpen"
				:nav
				:type="EBookerLocationType.START"
				@selectLocation="selectStartLocation" />
		</div>

		<Transition name="fade" mode="out-in">
			<Skeletor
				v-if="!isHydrated"
				class="global-booker__skeletor"
				:class="{ 'global-booker__skeletor--nav': nav, 'global-booker__skeletor--accordion': nav && accordion }" />
		</Transition>

		<Transition name="fade" mode="out-in">
			<div v-if="!bookerState.otherEndLocation" class="global-booker__field global-booker__end-location">
				<GlobalCheckbox v-model="bookerState.otherEndLocation">{{
					$t('components.booker.container.other_end_location_checkbox')
				}}</GlobalCheckbox>
			</div>
			<div v-else ref="endRef" class="global-booker__field">
				<v-btn flat class="global-booker__field-button" @click="openLocationMenu(EBookerLocationType.END)">
					<GlobalIcon :name="endLocationIcon" :height="20" class="global-booker__field-icon"></GlobalIcon>
					<Transition name="fade" mode="out-in">
						<div v-if="bookerState.selectedLocations.end?.isDelivery" class="global-booker__field-content">
							<div class="global-booker__field-label">{{ $t('components.booker.container.return_location_address') }}</div>
							<div class="global-booker__field-value global-booker__field-value--end">
								<!-- <span v-if="bookerState.selectedLocations.end.city">{{ bookerState.selectedLocations.end.city }},</span> -->
								{{ title(bookerState.selectedLocations.end) }}
							</div>
						</div>
						<template v-else>
							<Transition name="fade" mode="out-in">
								<div v-if="!bookerState.selectedLocations.end" class="global-booker__field-content">
									<div class="global-booker__field-label">{{ $t('components.booker.container.end_location_label') }}</div>
									<div class="global-booker__field-value">{{ $t('components.booker.container.end_location_placeholder') }}</div>
								</div>
								<div v-else class="global-booker__field-content">
									<div class="global-booker__field-label">{{ $t('components.booker.container.end_location_placeholder') }}</div>
									<div class="global-booker__field-value global-booker__field-value--end">
										{{ title(bookerState.selectedLocations.end) }}
									</div>
								</div>
							</Transition>
						</template>
					</Transition>
					<ButtonIcon class="global-booker__field-button-cancel" @click="cancelLocation()">
						<GlobalIcon name="close" :height="23" />
					</ButtonIcon>
				</v-btn>
				<GlobalBookerLocationMenu
					v-if="bookerState.isEndLocationMenuOpen"
					v-model="bookerState.isEndLocationMenuOpen"
					:nav
					:type="EBookerLocationType.END"
					@selectLocation="selectEndLocation" />
			</div>
		</Transition>

		<div class="global-booker__field global-booker__start-date">
			<v-btn flat class="global-booker__field-button" @click="openDateMenu">
				<GlobalIcon name="calendar" :height="20" class="global-booker__field-icon"></GlobalIcon>
				<div v-if="bookerState.selectedDates.start" class="global-booker__field-content">
					<div class="global-booker__field-label">{{ $t('components.booker.container.pickup_date_label') }}</div>
					<div class="global-booker__field-value">
						{{ format(bookerState.selectedDates.start, 'dd MMM yyyy, HH:mm', { locale: bookerLocale }) }}
					</div>
				</div>
			</v-btn>
			<GlobalBookerDateMenu v-if="bookerState.isStartDateMenuOpen" v-model="bookerState.isStartDateMenuOpen" :nav></GlobalBookerDateMenu>
		</div>
		<div class="global-booker__field global-booker__end-date">
			<v-btn flat class="global-booker__field-button" @click="openDateMenu">
				<GlobalIcon name="calendar" :height="20" class="global-booker__field-icon"></GlobalIcon>

				<div v-if="bookerState.selectedDates.end" class="global-booker__field-content">
					<div class="global-booker__field-label">{{ $t('components.booker.container.dropoff_date_label') }}</div>
					<div class="global-booker__field-value">
						{{ format(bookerState.selectedDates.end, 'dd MMM yyyy, HH:mm', { locale: bookerLocale }) }}
					</div>
				</div>
			</v-btn>
		</div>
		<div class="global-booker__button" :class="{ 'global-booker__nav-button': nav }">
			<ButtonPrimary iconBefore="search-normal" class="global-booker__button-search" :disabled="isButtonDisabled" @click="searchCars"
				>{{ $t('components.booker.container.search_button') }}
			</ButtonPrimary>
		</div>
		<GlobalBookerOpinion
			v-if="!nav && isTablet_sm && location && locationRatingsForm.url && locationRatingsForm.ratingsCount && locationRatingsForm.ratings"
			class="global-booker__google"
			:googleUrl="locationRatingsForm.url"
			:countRatings="Number(locationRatingsForm.ratingsCount)"
			:ratings="locationRatingsForm.ratings"
			main />
		<GlobalBookerOpinion v-else-if="!nav && isTablet_sm && !location" class="global-booker__google" main />
	</div>
	<div
		v-if="(nav && accordion) || !nav"
		class="global-booker__end-location--mobile"
		:class="{ 'global-booker__end-location--accordion': nav && accordion }">
		<GlobalCheckbox v-model="bookerState.otherEndLocation">{{ $t('components.booker.container.other_end_location_checkbox') }}</GlobalCheckbox>
	</div>
</template>

<script lang="ts" setup>
import { Skeletor } from 'vue-skeletor'
import { format } from 'date-fns'
import { pl, enGB, fr, de, es, sk, cs } from 'date-fns/locale'
import { EBookerLocationType, ELocationPurpose } from '@/data/bookerData'

const bookerRef = ref<HTMLElement | null>(null)
const bookerWidth = ref(0)
const endRef = ref<HTMLElement | null>(null)
const locationModalOffset = ref(0)
const router = useRouter()
const bookerState = inject<Ref<IBookerState>>('bookerState')!
const state = inject<Ref<Record<string, boolean>>>('state')!
const localePath = useLocalePath()
const { locale } = useI18n()
const googleRatingsStore = useGoogleRatingsStore()
const bookingStore = useBookingStore()
const mapStore = useMapStore()
const route = useRoute()
const isHydrated = ref(false)

const isButtonDisabled = ref(true)

watch(
	() => bookerState.value.selectedLocations.start,
	() => {
		if (bookerState.value.selectedLocations.start) {
			isButtonDisabled.value = false
		} else {
			isButtonDisabled.value = true
		}
	},
	{ immediate: true, deep: true },
)

onMounted(async () => {
	isHydrated.value = true
	isButtonDisabled.value = true
	await nextTick()
	isButtonDisabled.value = bookerState.value.selectedLocations?.start === null
})

const props = defineProps<{
	nav?: boolean
	accordion?: boolean
	location?: boolean
}>()

const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const locationRatingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const selectStartLocation = (location: any) => {
	bookerState.value.selectedLocations.start = location
}

const selectEndLocation = (location: any) => {
	bookerState.value.isEndLocationMenuOpen = false
	bookerState.value.selectedLocations.end = location
}

if (!props.location) {
	await googleRatingsStore.fetchGoogleRating()
} else {
	const assignedLocations = inject<Ref<ILocationModel[]>>('assignedLocations')!
	if (assignedLocations && assignedLocations.value.length > 0) {
		locationRatingsForm.stars = assignedLocations.value[0].ratings
		locationRatingsForm.ratings = assignedLocations.value[0].ratings
		locationRatingsForm.ratingsCount = assignedLocations.value[0].countRatings
		locationRatingsForm.url = assignedLocations.value[0].googleUrl
	}
}

watch(
	() => googleRatingsStore.getGoogleRating,
	(v) => {
		if (v) {
			ratingsForm.stars = v.stars
			ratingsForm.ratings = v.ratings
			ratingsForm.ratingsCount = v.ratingsCount
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)

provide('ratingsForm', ratingsForm)

const cancelLocation = () => {
	bookerState.value.otherEndLocation = false
	bookingStore.setBookerLocations({ ...bookerState.value.selectedLocations, end: null })
	bookingStore.updateBooking()
}

const bookerLocale = computed(() => {
	switch (locale.value) {
		case 'pl':
			return pl
		case 'en':
			return enGB
		case 'fr':
			return fr
		case 'de':
			return de
		case 'es':
			return es
		case 'sk':
			return sk
		case 'cs':
			return cs
		default:
			return enGB
	}
})

provide('bookerWidth', bookerWidth)
provide('locationModalOffset', locationModalOffset)

const startLocationIcon = computed(() => {
	const { start } = bookerState.value.selectedLocations
	return start && start.icon ? start.icon : start?.isDelivery ? 'routing' : 'location'
})

const endLocationIcon = computed(() => {
	const { end } = bookerState.value.selectedLocations
	return end && end.icon ? end.icon : end?.isDelivery ? 'routing' : 'location'
})

onMounted(() => {
	if (bookerRef.value) {
		bookerWidth.value = (window.innerWidth - bookerRef.value.clientWidth) / 2
		window.addEventListener('resize', function () {
			if (!bookerRef.value) return
			bookerWidth.value = (window.innerWidth - bookerRef.value.clientWidth) / 2
		})
	}

	if (route.name?.toString().includes('cars') && mapStore.getClickedLocation) {
		selectStartLocation(mapStore.getClickedLocation)
		mapStore.setClickedLocation(null)
	}

	if (!endRef.value) return
	window.addEventListener('resize', function () {
		if (!endRef.value) return
		locationModalOffset.value = endRef.value.getBoundingClientRect().left
	})
})

watch(
	() => endRef.value,
	() => {
		if (endRef.value) locationModalOffset.value = endRef.value.getBoundingClientRect().left
	},
)

const { isTablet_sm } = useWindowWidth()

const openLocationMenu = (type: EBookerLocationType) => {
	if (type === EBookerLocationType.START) {
		bookerState.value.isStartLocationMenuOpen = true
	} else {
		bookerState.value.isEndLocationMenuOpen = true
	}
	router.push(localePath({ hash: '#location' }))
}

const openDateMenu = () => {
	bookerState.value.isStartDateMenuOpen = true
	router.push(localePath({ hash: '#date' }))
}

watch(
	() => bookerState.value.isStartDateMenuOpen,
	(newValue, oldValue) => {
		if (oldValue === true && newValue === false) {
			replaceWithoutHash(router.currentRoute.value.path)
		}
	},
)

watch(
	() => bookerState.value.isStartLocationMenuOpen,
	(newValue, oldValue) => {
		if (oldValue === true && newValue === false) {
			replaceWithoutHash(router.currentRoute.value.path)
		}
	},
)

watch(
	() => bookerState.value.isEndLocationMenuOpen,
	(newValue, oldValue) => {
		if (oldValue === true && newValue === false) {
			replaceWithoutHash(router.currentRoute.value.path)
		}
	},
)

// watch(
// 	() => bookerState.value.otherEndLocation,
// 	(newValue, oldValue) => {
// 		if (oldValue === false && newValue === true) {
// 			bookerState.value.isEndLocationMenuOpen = true
// 		}
// 	},
// )

const replaceWithoutHash = (path: string) => {
	const scrollX = window.scrollX
	const scrollY = window.scrollY
	window.history.replaceState(null, '', path)
	window.scrollTo(scrollX, scrollY)
}

const searchCars = () => {
	const cookie = useCookie('cf-car')
	if (cookie.value) {
		bookingStore.updateSelectedCar(cookie.value)
		router.push(localePath({ name: 'reservation', query: { step: '1' } }))
		cookie.value = null
	} else {
		router.push(localePath('cars'))
	}
	state.value.booker = false
	sendAnalyticsData()
}

const i18nService = usei18nService()

const title = (location: any) => {
	if (!location.city) return location.name
	else if (location.purpose === ELocationPurpose.MEET_AND_GREET)
		return `${i18nService.$tDynamic('data.cities', location.city)}, ${locale.value === 'pl' ? location.name : location.nameEn}`
	else if ((location.city && location.icon === 'airplane') || (location.city && location.icon === 'train')) {
		return `${locale.value === 'pl' ? location.name : location.nameEn}`
	} else {
		return `${i18nService.$tDynamic('data.cities', location.city)}, ${location.address_street} ${location.address_house_number ?? ''}`
	}
}

const sendAnalyticsData = () => {
	const gtmService = useGTMService()
	if (!gtmService) return
	gtmService.searchButtonClicked({})
}
</script>

<style lang="scss">
@import '@/assets/scss/utils/accordion.scss';
@import 'vue-skeletor/dist/vue-skeletor.css';
@import './Container';
</style>
